import React, {useEffect} from 'react';
import clsx from 'clsx';
import AppVerticalMenu from '../AppVerticalNav';
import {useLocation} from 'react-router-dom';
import {LayoutDirection} from '@erkport/constants/AppEnums';
import {useSidebarContext} from '@erkport/context/AppContextProvider/SidebarContextProvider';
import {useLayoutContext} from '@erkport/context/AppContextProvider/LayoutContextProvider';
import {
  StyledAppDrawer,
  StyledAppDrawerLayoutSidebar,
  StyledAppDrawerSidebarScrollbar,
} from './index.styled';
import {RouterConfigData} from '@erkport/types/Apps';
import AppLogo from '../AppLogo';
import {Divider} from 'antd';
import AppDivider from '@erkport/components/AppDivider';

type AppSidebarProps = {
  visible: boolean;
  onClose: () => void;
  routesConfig: RouterConfigData[];
};

const AppSidebar = ({visible, onClose, routesConfig}: AppSidebarProps) => {
  const {allowSidebarBgImage} = useSidebarContext();
  const {direction} = useLayoutContext();
  const {pathname} = useLocation();

  useEffect(() => {
    onClose();
  }, [pathname]);

  return (
    <StyledAppDrawer
      placement={direction === LayoutDirection.LTR ? 'left' : 'right'}
      closable={false}
      onClose={onClose}
      open={visible}
    >
      <StyledAppDrawerLayoutSidebar
        className={clsx({
          'drawerLayout-sidebar-img-background': allowSidebarBgImage,
        })}
        collapsible
      >
        <AppLogo />
        <AppDivider />
        <StyledAppDrawerSidebarScrollbar scrollToTop={false}>
          <AppVerticalMenu routesConfig={routesConfig} />
        </StyledAppDrawerSidebarScrollbar>
      </StyledAppDrawerLayoutSidebar>
    </StyledAppDrawer>
  );
};

export default AppSidebar;
